var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4014 7.33186V11.3974M11.4014 15.4629H11.4115M21.2912 16.4795L13.1601 2.25017C12.9828 1.93733 12.7257 1.67712 12.415 1.49609C12.1044 1.31505 11.7512 1.21967 11.3916 1.21967C11.032 1.21967 10.6789 1.31505 10.3682 1.49609C10.0575 1.67712 9.80041 1.93733 9.62311 2.25017L1.49205 16.4795C1.31285 16.7899 1.21888 17.1421 1.21967 17.5005C1.22046 17.8589 1.31599 18.2107 1.49657 18.5202C1.67715 18.8298 1.93636 19.0861 2.24793 19.2632C2.5595 19.4403 2.91235 19.5319 3.27072 19.5287H19.5328C19.8895 19.5283 20.2398 19.4341 20.5485 19.2556C20.8572 19.077 21.1135 18.8204 21.2917 18.5114C21.4699 18.2024 21.5636 17.852 21.5635 17.4954C21.5634 17.1387 21.4695 16.7884 21.2912 16.4795Z",
    stroke: "#F59E0B",
    strokeWidth: 2.43932,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.4bafa89a9638ce7679410f54f7734db8.svg";
export { ForwardRef as ReactComponent };